module.exports = __webpack_public_path__ + "img/bp_download_appstore.e96ee252.png";